if (!customElements.get("open-modal")) {
	customElements.define(
		"open-modal",
		class OpenModal extends HTMLElement {
			constructor() {
				super();
			}

			connectedCallback() {
				this.modal = document.getElementById(this.dataset.target);
				if (!this.modal) return;

				this.modalClose = this.modal.querySelector(".modal-close");
				this.modalOverlay = this.modal.querySelector(".modal-overlay");

				this.addEventListener("click", this.openModal.bind(this));
				this.modalClose.addEventListener("click", this.closeModal.bind(this));
				this.modalOverlay.addEventListener("click", this.closeModal.bind(this));
			}

			openModal() {
				this.modal.classList.add("active");
				document.documentElement.style.overflow = "hidden";
			}

			closeModal() {
				this.modal.classList.remove("active");
				document.documentElement.style.overflow = "visible";
			}
		}
	);
}
